import { render } from "./ModernGameDev.vue?vue&type=template&id=3c99a98c&scoped=true"
import script from "./ModernGameDev.vue?vue&type=script&lang=js"
export * from "./ModernGameDev.vue?vue&type=script&lang=js"

import "./ModernGameDev.vue?vue&type=style&index=0&id=3c99a98c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c99a98c"]])

export default __exports__